export default "/images/claritask-dark.svg?db6d4ac30b0bd3c5a281512808f73fec";